import { LinkOutlined } from '@ant-design/icons';
import { Button as BaseButton, Dropdown, message } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { getAppBroker } from 'stores/AppBroker';
import * as DatabasePaths from 'stores/DatabasePaths';
import store from 'stores/RootStore';
import type Tearsheet from 'stores/Tearsheet';
import { ViewModes } from 'types/ViewModes';

const Button = styled(BaseButton)`
  align-items: center;
  display: flex;
  font-size: 14px;
  padding: 0 9px;
`;

function getTearsheetAdLinks(tearsheet: Tearsheet) {
  const tearsheetCoord = DatabasePaths.tearsheet.requireMatch(tearsheet.path);

  return tearsheet.ads.all.map((ad) => {
    const nominal1BasedIndex = ad.nominal1BasedIndex;
    const label = ad.label;

    const pathname = getAppBroker().routeForDocument({
      ...tearsheetCoord,
      adIndex: `${nominal1BasedIndex}`,
    });
    const url = new URL(pathname, window.document.baseURI);
    url.searchParams.set('mode', ViewModes.FRAMELESS);

    return { label, url };
  });
}

function CopyLinksButton() {
  const store_tearsheet = store.tearsheet;

  const copyLabeledLinksToClipboard = async () => {
    if (!store_tearsheet) return;
    const copyString = getTearsheetAdLinks(store_tearsheet)
      .map(({ label, url }) => `${label} - ${url}\n`)
      .join('');
    await navigator.clipboard.writeText(copyString);
    message.success('Ad links copied.');
  };

  const copyURLsToClipboard = async () => {
    if (!store_tearsheet) return;
    const copyString = getTearsheetAdLinks(store_tearsheet)
      .map(({ url }) => `${url}\n`)
      .join('');
    await navigator.clipboard.writeText(copyString);
    message.success('Ad links copied.');
  };

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: [
          {
            key: 'Labeled',
            label: 'Labeled',
            onClick: copyLabeledLinksToClipboard,
            disabled: !store_tearsheet,
          },
          {
            key: 'URLs',
            label: 'URLs',
            onClick: copyURLsToClipboard,
            disabled: !store_tearsheet,
          },
        ],
      }}
    >
      <Button>
        <LinkOutlined />
        Copy Links
      </Button>
    </Dropdown>
  );
}

export default observer(CopyLinksButton);
